/* ============================================================
   Endlessprints theme JS — real Shopify version.
   Uses the AJAX Cart API; everything degrades gracefully to
   native form posts if JS fails.
   ============================================================ */
(function () {
  "use strict";

  function toast(msg) {
    var t = document.querySelector(".ep-toast");
    if (!t) { t = document.createElement("div"); t.className = "ep-toast"; document.body.appendChild(t); }
    t.textContent = msg;
    t.classList.add("show");
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.classList.remove("show"); }, 2600);
  }

  function refreshCartCount() {
    fetch("/cart.js").then(function (r) { return r.json(); }).then(function (cart) {
      document.querySelectorAll("[data-cart-count]").forEach(function (el) {
        el.textContent = cart.item_count;
        el.classList.toggle("has-items", cart.item_count > 0);
      });
    }).catch(function () {});
  }

  document.addEventListener("click", function (e) {
    /* Quick add from product cards */
    var quick = e.target.closest("[data-quick-add]");
    if (quick) {
      quick.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ id: parseInt(quick.getAttribute("data-quick-add"), 10), quantity: 1 })
      }).then(function (r) {
        if (!r.ok) throw new Error();
        return r.json();
      }).then(function (item) {
        toast("Added to basket — " + item.product_title);
        refreshCartCount();
      }).catch(function () {
        toast("Couldn't add that — try the product page.");
      }).finally(function () { quick.disabled = false; });
      return;
    }

    /* Mobile nav: expand/collapse dropdown sub-menus */
    var subToggle = e.target.closest("[data-sub-toggle]");
    if (subToggle) {
      var item = subToggle.closest(".nav__item");
      var opened = item.classList.toggle("is-open");
      subToggle.setAttribute("aria-expanded", opened);
      return;
    }

    /* Mobile nav drawer */
    var burger = e.target.closest("[data-menu-toggle]");
    if (burger) {
      var nav = document.querySelector("[data-nav]");
      var open = nav.classList.toggle("is-open");
      document.body.classList.toggle("nav-open", open);
      var toggle = document.querySelector(".menu-toggle");
      if (toggle) toggle.setAttribute("aria-expanded", open);
      return;
    }

    /* Product page quantity */
    var minus = e.target.closest("[data-qty-minus]");
    var plus = e.target.closest("[data-qty-plus]");
    if (minus || plus) {
      var box = (minus || plus).closest(".qty");
      var input = box.querySelector("input");
      input.value = Math.max(parseInt(input.min || "0", 10), (+input.value || 1) + (plus ? 1 : -1));
      /* Cart page: submit the surrounding cart form so totals update */
      var lineInput = box.querySelector("[data-line-qty]");
      if (lineInput) {
        var form = box.closest("form");
        if (form) form.submit();
      }
      return;
    }
  });

  /* ============================================================
     Product gallery — thumbnail strip swaps the main photo.
     Exposes epGallery.showById() so the variant picker can jump
     to a variant's own image.
     ============================================================ */
  var epGallery = (function () {
    var api = { showById: function () {} };
    var gallery = document.querySelector("[data-gallery]");
    if (!gallery) return api;
    var main = gallery.querySelector(".product__media-main img");
    var thumbs = [].slice.call(gallery.querySelectorAll("[data-gallery-thumb]"));
    if (!main || !thumbs.length) return api;

    function show(thumb) {
      if (!thumb || thumb.classList.contains("is-active")) return;
      main.src = thumb.getAttribute("data-full");
      main.srcset = thumb.getAttribute("data-full-srcset") || "";
      main.alt = thumb.getAttribute("data-alt") || "";
      thumbs.forEach(function (t) {
        var on = t === thumb;
        t.classList.toggle("is-active", on);
        if (on) { t.setAttribute("aria-current", "true"); }
        else { t.removeAttribute("aria-current"); }
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener("click", function () { show(thumb); });
      thumb.addEventListener("keydown", function (e) {
        var step = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        var next = thumbs[(i + step + thumbs.length) % thumbs.length];
        next.focus();
        show(next);
      });
    });

    api.showById = function (id) {
      if (!id) return;
      show(thumbs.filter(function (t) {
        return t.getAttribute("data-image-id") === String(id);
      })[0]);
    };
    return api;
  })();

  /* ============================================================
     Variant (size) picker — pill radios per option; keeps the
     hidden variant id, price and Klarna line in sync.
     ============================================================ */
  (function () {
    var picker = document.querySelector("[data-variant-picker]");
    if (!picker) return;
    var variants;
    try { variants = JSON.parse(picker.querySelector("[data-variants-json]").textContent); }
    catch (err) { return; }
    var form = picker.closest("form");
    var idInput = form.querySelector("[data-variant-id]");
    var priceWrap = document.querySelector(".product__price");
    var atc = form.querySelector(".product__atc");
    var fmt = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: (priceWrap && priceWrap.getAttribute("data-currency")) || "GBP"
    });

    picker.addEventListener("change", function () {
      var chosen = [];
      picker.querySelectorAll("input[type=radio]:checked").forEach(function (r) {
        chosen[+r.getAttribute("data-opt-idx")] = r.value;
      });
      var match = variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === chosen[i]; });
      })[0];
      if (!match) return;
      idInput.value = match.id;
      if (match.featured_image) epGallery.showById(match.featured_image.id);
      var price = document.querySelector("[data-price]");
      if (price) price.textContent = fmt.format(match.price / 100);
      var inst = document.querySelector("[data-installment]");
      if (inst) inst.textContent = fmt.format(match.price / 300);
      if (atc) {
        if (!atc.getAttribute("data-label")) atc.setAttribute("data-label", atc.innerHTML);
        atc.disabled = !match.available;
        atc.innerHTML = match.available ? atc.getAttribute("data-label") : "Sold out";
      }
      /* keep the URL shareable at the chosen size */
      if (window.history && history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set("variant", match.id);
        history.replaceState({}, "", u);
      }
    });
  })();

  /* ============================================================
     Built-in live customiser.
     Customer flow: upload photo → drag/resize it on the real
     product photo (clipped to the print area) → optional text →
     save. The product form then carries: original photo file,
     "Text to print", and a composited "Design preview" PNG
     for the print team.
     ============================================================ */
  var epState = null; // persists between opens so "Edit design" restores

  function epIcon(paths) {
    return '<svg class="icon" viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + paths + "</svg>";
  }
  var IC_UP = epIcon('<path d="M12 16V4m0 0 4 4m-4-4-4 4"/><path d="M4 16v3a1.5 1.5 0 0 0 1.5 1.5h13A1.5 1.5 0 0 0 20 19v-3"/>');
  var IC_OK = epIcon('<path d="m5 12.5 4.5 4.5L19 7.5"/>');
  var IC_X = epIcon('<path d="M6 6l12 12M18 6L6 18"/>');

  function loadThree(src, cb) {
    if (window.THREE) { cb(true); return; }
    var s = document.createElement("script");
    s.src = src;
    s.onload = function () { cb(true); };
    s.onerror = function () { cb(false); };
    document.head.appendChild(s);
  }

  function openEpCustomizer(btn) {
    var area = (btn.getAttribute("data-area") || "30,26,42,46,3").split(",").map(Number);
    var cfg = {
      preview: btn.getAttribute("data-preview"),
      title: btn.getAttribute("data-ptitle") || "your gift",
      is3d: btn.hasAttribute("data-ep-3d"),
      threeSrc: btn.getAttribute("data-three-src"),
      x: area[0], y: area[1], w: area[2], h: area[3], r: area[4] || 0
    };
    var st = epState && epState.preview === cfg.preview ? epState
      : { preview: cfg.preview, file: null, url: null, text: "", scale: 1, dx: 0, dy: 0,
          tx: 0, ty: 0, tsize: 1, tcolor: "#2b2440" };

    var previewPane = cfg.is3d
      ? '<div class="customizer__preview customizer__preview--3d">' +
        '<div class="ep-cz-stage ep-cz-stage--3d" data-stage3d></div>' +
        '<p class="ep-cz-dragnote">Drag the mug to spin it</p>' +
        '<div class="ep-flat-wrap"><span class="ep-flat-label">Print layout — drag your photo to position it</span>' +
        '<canvas class="ep-flat" data-flat width="1024" height="512"></canvas></div></div>'
      : '<div class="customizer__preview"><div class="ep-cz-stage" data-stage>' +
        '<img class="ep-cz-base" src="' + cfg.preview + '" alt="" crossorigin="anonymous" draggable="false">' +
        '<div class="ep-cz-zone" data-zone style="left:' + cfg.x + "%;top:" + cfg.y + "%;width:" + cfg.w + "%;height:" + cfg.h + "%;border-radius:" + cfg.r + '%">' +
        '<img class="ep-cz-photo" data-photo alt="" draggable="false" hidden>' +
        '<span class="ep-cz-hint" data-hint>Your photo appears here</span>' +
        '<span class="ep-cz-caption" data-caption></span>' +
        "</div></div>" +
        '<p class="ep-cz-dragnote" data-dragnote hidden>Drag your photo to position it · use the slider to zoom</p>' +
        "</div>";

    var overlay = document.createElement("div");
    overlay.className = "customizer-overlay";
    overlay.innerHTML =
      '<div class="customizer-wrap"><div class="customizer" role="dialog" aria-modal="true" aria-label="Personalise ' + cfg.title + '">' +
      previewPane +
      '<div class="customizer__panel">' +
      "<h3>Make it yours</h3>" +
      '<p class="hint">What you see here is exactly what we print.</p>' +
      '<div class="customizer__field"><label>1 · Your photo</label>' +
      '<div class="customizer__drop" data-drop tabindex="0" role="button">' + IC_UP + "<span data-drop-label><strong>Upload a photo</strong> — JPG, PNG, HEIC</span></div>" +
      '<input type="file" accept="image/*" data-file class="visually-hidden"></div>' +
      '<div class="customizer__field" data-zoom-field hidden><label for="ep-zoom">Zoom</label>' +
      '<input type="range" id="ep-zoom" data-zoom min="100" max="300" value="' + Math.round(st.scale * 100) + '"></div>' +
      '<div class="customizer__field"><label for="ep-text">2 · Add text (optional)</label>' +
      '<input type="text" id="ep-text" data-text maxlength="40" placeholder="e.g. World\'s Best Dad" value="' + (st.text || "").replace(/"/g, "&quot;") + '"></div>' +
      (cfg.is3d
        ? '<div class="customizer__field ep-textstyle" data-textstyle hidden><label for="ep-tsize">Text size &amp; colour <small>(drag the text on the layout to move it)</small></label>' +
          '<input type="range" id="ep-tsize" data-tsize min="50" max="220" value="' + Math.round((st.tsize || 1) * 100) + '">' +
          '<div class="ep-swatches">' +
          ["#2b2440", "#ffffff", "#e5378a", "#12a5a0", "#c02070", "#1c6fd4", "#e8b323"].map(function (c) {
            return '<button type="button" class="ep-swatch' + (st.tcolor === c ? " is-active" : "") + '" data-swatch="' + c + '" style="background:' + c + '" aria-label="Text colour ' + c + '"></button>';
          }).join("") + "</div></div>"
        : "") +
      '<div class="customizer__actions">' +
      '<button type="button" class="btn-primary" data-save>' + IC_OK + " Looks perfect — save my design</button>" +
      '<button type="button" class="btn-ghost" data-cancel>Cancel</button></div>' +
      "</div></div>" +
      '<button class="customizer__close" data-cancel aria-label="Close">' + IC_X + "</button></div>";
    document.body.appendChild(overlay);
    document.body.style.overflow = "hidden";

    var photo = overlay.querySelector("[data-photo]");
    var zone = overlay.querySelector("[data-zone]");
    var hint = overlay.querySelector("[data-hint]");
    var caption = overlay.querySelector("[data-caption]");
    var drop = overlay.querySelector("[data-drop]");
    var dropLabel = overlay.querySelector("[data-drop-label]");
    var fileInput = overlay.querySelector("[data-file]");
    var zoomField = overlay.querySelector("[data-zoom-field]");
    var zoom = overlay.querySelector("[data-zoom]");
    var textInput = overlay.querySelector("[data-text]");
    var dragnote = overlay.querySelector("[data-dragnote]");
    var three = null; /* 3D context, set by setup3D */

    function paintPhoto() {
      if (!st.url) return;
      zoomField.hidden = false;
      dropLabel.innerHTML = "<strong>" + (st.file ? st.file.name : "Photo added") + "</strong> — tap to change";
      if (three) { three.setPhoto(st.url); return; }
      if (!photo) return;
      photo.src = st.url;
      photo.hidden = false;
      hint.hidden = true;
      if (dragnote) dragnote.hidden = false;
      photo.style.transform = "translate(calc(-50% + " + st.dx + "px), calc(-50% + " + st.dy + "px)) scale(" + st.scale + ")";
    }
    function paintText() {
      if (three) { three.update(); return; }
      if (!caption) return;
      caption.textContent = st.text;
      caption.style.display = st.text ? "block" : "none";
    }

    /* 3D mug mode: design auto-wraps around a spinnable mug */
    if (cfg.is3d && cfg.threeSrc) {
      loadThree(cfg.threeSrc, function (ok) {
        var mount = overlay.querySelector("[data-stage3d]");
        if (ok && window.THREE && mount) {
          try { three = setupMug3D(mount, st); } catch (err) { three = null; }
        }
        if (!three && mount) {
          /* WebGL unavailable — fall back to the flat product photo */
          mount.outerHTML = '<div class="ep-cz-stage"><img class="ep-cz-base" src="' + cfg.preview + '" alt=""></div>';
        }
        paintPhoto(); paintText();
      });
    } else {
      paintPhoto(); paintText();
    }

    function setFile(f) {
      if (!f || !f.type || f.type.indexOf("image/") !== 0) return;
      st.file = f;
      st.url = URL.createObjectURL(f);
      st.scale = 1; st.dx = 0; st.dy = 0;
      zoom.value = 100;
      paintPhoto();
    }
    drop.addEventListener("click", function () { fileInput.click(); });
    drop.addEventListener("keydown", function (e) { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); fileInput.click(); } });
    fileInput.addEventListener("change", function () { setFile(fileInput.files[0]); });
    ["dragover", "dragleave", "drop"].forEach(function (ev) {
      drop.addEventListener(ev, function (e) {
        e.preventDefault();
        drop.classList.toggle("dragover", ev === "dragover");
        if (ev === "drop") setFile(e.dataTransfer.files[0]);
      });
    });
    zoom.addEventListener("input", function () { st.scale = zoom.value / 100; paintPhoto(); });
    var textStyle = overlay.querySelector("[data-textstyle]");
    textInput.addEventListener("input", function () {
      st.text = textInput.value;
      if (textStyle) textStyle.hidden = !st.text;
      paintText();
    });
    if (textStyle) {
      textStyle.hidden = !st.text;
      overlay.querySelector("[data-tsize]").addEventListener("input", function (e) {
        st.tsize = e.target.value / 100;
        paintText();
      });
      overlay.querySelectorAll("[data-swatch]").forEach(function (sw) {
        sw.addEventListener("click", function () {
          st.tcolor = sw.getAttribute("data-swatch");
          overlay.querySelectorAll("[data-swatch]").forEach(function (s) { s.classList.toggle("is-active", s === sw); });
          paintText();
        });
      });
    }

    /* Drag to reposition (2D mode only; 3D mode drags the mug itself) */
    if (zone) {
      var drag = null;
      zone.addEventListener("pointerdown", function (e) {
        if (!st.url) return;
        drag = { x: e.clientX, y: e.clientY, dx: st.dx, dy: st.dy };
        zone.setPointerCapture(e.pointerId);
        e.preventDefault();
      });
      zone.addEventListener("pointermove", function (e) {
        if (!drag) return;
        st.dx = drag.dx + (e.clientX - drag.x);
        st.dy = drag.dy + (e.clientY - drag.y);
        paintPhoto();
      });
      zone.addEventListener("pointerup", function () { drag = null; });
      zone.addEventListener("pointercancel", function () { drag = null; });
    }

    function close() {
      if (three) three.dispose();
      overlay.remove();
      document.body.style.overflow = "";
    }
    overlay.querySelectorAll("[data-cancel]").forEach(function (b) { b.addEventListener("click", close); });
    overlay.addEventListener("click", function (e) { if (e.target === overlay) close(); });
    document.addEventListener("keydown", function esc(e) { if (e.key === "Escape") { close(); document.removeEventListener("keydown", esc); } });

    /* Save: write everything into the product form */
    overlay.querySelector("[data-save]").addEventListener("click", function () {
      if (!st.file && !st.text) { close(); return; }
      epState = st;
      var form = document.querySelector("form.product__form");
      if (!form) { close(); return; }
      var fFile = form.querySelector("[data-ep-file]");
      var fPrev = form.querySelector("[data-ep-preview-file]");
      var fText = form.querySelector("[data-ep-text-prop]");

      if (st.file && fFile) {
        var dt = new DataTransfer();
        dt.items.add(st.file);
        fFile.files = dt.files;
        fFile.disabled = false;
      }
      var fLayout = form.querySelector("[data-ep-layout-file]");
      if (fText) { fText.value = st.text || ""; fText.disabled = !st.text; }
      var summary = document.querySelector("[data-ep-summary]");
      if (summary) summary.hidden = false;

      function attach(input, file) {
        if (!input || !file) return;
        var dt2 = new DataTransfer();
        dt2.items.add(file);
        input.files = dt2.files;
        input.disabled = false;
      }
      function finish() {
        toast("Design saved — add it to your basket when you're ready");
        close();
      }

      if (three) {
        /* 3D: snapshot the mug for the preview, plus the flat wrap
           canvas as a ready-to-print sublimation layout */
        three.snapshot(function (previewFile) {
          attach(fPrev, previewFile);
          three.layout(function (layoutFile) {
            attach(fLayout, layoutFile);
            finish();
          });
        });
      } else {
        buildCompositePreview(overlay, st, function (file) {
          attach(fPrev, file);
          finish();
        });
      }
    });
  }

  /* ============================================================
     3D mug: white cylinder + black rim/handle/inner (matches the
     product range), with the design canvas wrapped as its texture.
     Returns { setPhoto, update, snapshot, layout, dispose }.
     ============================================================ */
  function setupMug3D(mount, st) {
    var T = window.THREE;
    var size = Math.min(mount.clientWidth || 380, 440);

    /* The flat design canvas — this exact image is the print layout */
    var tex = document.createElement("canvas");
    tex.width = 2048; tex.height = 1024;
    var tctx = tex.getContext("2d");
    var photoImg = null, photoUrl = null;

    var flat = mount.parentElement.querySelector("[data-flat]");
    var fctx = flat ? flat.getContext("2d") : null;

    function drawTexture() {
      tctx.fillStyle = "#ffffff";
      tctx.fillRect(0, 0, tex.width, tex.height);
      if (photoImg && photoImg.complete && photoImg.naturalWidth) {
        /* photo positioned by the flat editor (st.dx/dy in texture px),
           drawn three times so it wraps seamlessly across the seam */
        var h = tex.height * 0.8 * st.scale;
        var w = h * (photoImg.naturalWidth / photoImg.naturalHeight);
        var cx = tex.width * 0.5 + st.dx;
        var cy = tex.height * 0.46 + st.dy;
        [-tex.width, 0, tex.width].forEach(function (off) {
          tctx.drawImage(photoImg, cx - w / 2 + off, cy - h / 2, w, h);
        });
      }
      if (st.text) {
        var fs = Math.round(tex.height * 0.1 * (st.tsize || 1));
        var txx = tex.width * 0.5 + (st.tx || 0);
        var txy = tex.height * 0.88 + (st.ty || 0);
        tctx.font = "700 " + fs + "px Quicksand, sans-serif";
        tctx.textAlign = "center";
        tctx.lineWidth = fs * 0.2;
        /* outline flips for contrast so white text stays readable */
        tctx.strokeStyle = st.tcolor === "#ffffff" ? "rgba(43,36,64,.85)" : "rgba(255,255,255,.92)";
        tctx.fillStyle = st.tcolor || "#2b2440";
        [-tex.width, 0, tex.width].forEach(function (off) {
          tctx.strokeText(st.text, txx + off, txy);
          tctx.fillText(st.text, txx + off, txy);
        });
      }
      texture.needsUpdate = true;
      if (fctx) fctx.drawImage(tex, 0, 0, flat.width, flat.height);
    }

    /* Flat print-layout editor: drag = move the photo on the wrap */
    if (flat) {
      var fdrag = null;
      flat.style.touchAction = "none";
      flat.addEventListener("pointerdown", function (e) {
        if (!photoImg && !st.text) return;
        var r = flat.getBoundingClientRect();
        var k = tex.width / r.width;
        var px = (e.clientX - r.left) * k;
        var py = (e.clientY - r.top) * (tex.height / r.height);
        /* hit-test the text first so it can be dragged independently */
        var onText = false;
        if (st.text) {
          var fs = tex.height * 0.1 * (st.tsize || 1);
          var txx = tex.width * 0.5 + (st.tx || 0);
          var txy = tex.height * 0.88 + (st.ty || 0);
          var halfW = Math.max(fs * st.text.length * 0.3, fs);
          onText = Math.abs(px - txx) < halfW && py > txy - fs * 1.2 && py < txy + fs * 0.4;
        }
        fdrag = onText
          ? { t: true, x: e.clientX, y: e.clientY, dx: st.tx || 0, dy: st.ty || 0 }
          : (photoImg ? { t: false, x: e.clientX, y: e.clientY, dx: st.dx, dy: st.dy } : null);
        if (fdrag) { flat.setPointerCapture(e.pointerId); e.preventDefault(); }
      });
      flat.addEventListener("pointermove", function (e) {
        if (!fdrag) return;
        var k = tex.width / flat.getBoundingClientRect().width;
        var nx = fdrag.dx + (e.clientX - fdrag.x) * k;
        var ny = fdrag.dy + (e.clientY - fdrag.y) * k / 2;
        if (fdrag.t) {
          st.tx = nx;
          st.ty = Math.max(-tex.height * 0.8, Math.min(tex.height * 0.11, ny));
        } else {
          st.dx = nx;
          st.dy = Math.max(-tex.height * 0.4, Math.min(tex.height * 0.4, ny));
        }
        drawTexture();
      });
      flat.addEventListener("pointerup", function () { fdrag = null; });
      flat.addEventListener("pointercancel", function () { fdrag = null; });
    }

    var renderer = new T.WebGLRenderer({ antialias: true, alpha: true, preserveDrawingBuffer: true });
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    renderer.setSize(size, size);
    mount.appendChild(renderer.domElement);

    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(32, 1, 0.1, 100);
    camera.position.set(0, 1.1, 8.2);
    camera.lookAt(0, 0, 0);
    scene.add(new T.AmbientLight(0xffffff, 0.85));
    var dir = new T.DirectionalLight(0xffffff, 0.65);
    dir.position.set(3, 5, 4);
    scene.add(dir);
    var dir2 = new T.DirectionalLight(0xffffff, 0.25);
    dir2.position.set(-4, 2, -3);
    scene.add(dir2);

    var texture = new T.CanvasTexture(tex);
    texture.anisotropy = 4;

    var mug = new T.Group();
    var black = new T.MeshPhongMaterial({ color: 0x1c1c22, shininess: 40 });
    var white = new T.MeshPhongMaterial({ color: 0xffffff, shininess: 30 });

    /* printed outer wall */
    mug.add(new T.Mesh(
      new T.CylinderGeometry(1.3, 1.3, 3, 96, 1, true),
      new T.MeshPhongMaterial({ map: texture, shininess: 26 })
    ));
    /* black inner wall + rim + base */
    var inner = new T.Mesh(new T.CylinderGeometry(1.24, 1.24, 2.96, 96, 1, true), black.clone());
    inner.material.side = T.BackSide;
    mug.add(inner);
    mug.add(new T.Mesh(new T.TorusGeometry(1.27, 0.055, 14, 96), black).translateY(1.5).rotateX(Math.PI / 2));
    var innerBottom = new T.Mesh(new T.CircleGeometry(1.24, 96), black);
    innerBottom.rotation.x = -Math.PI / 2; innerBottom.position.y = -1.44;
    mug.add(innerBottom);
    var base = new T.Mesh(new T.CircleGeometry(1.3, 96), white);
    base.rotation.x = Math.PI / 2; base.position.y = -1.5;
    mug.add(base);
    /* black handle */
    var handle = new T.Mesh(new T.TorusGeometry(0.58, 0.15, 18, 60), black);
    handle.position.set(1.46, 0, 0);
    handle.scale.set(1, 1.25, 1);
    mug.add(handle);

    mug.rotation.y = -0.35; /* show a hint of the handle */
    scene.add(mug);

    /* drag to spin */
    var spin = null, userTouched = false;
    var el = renderer.domElement;
    el.style.touchAction = "none";
    el.addEventListener("pointerdown", function (e) {
      spin = { x: e.clientX, ry: mug.rotation.y };
      userTouched = true;
      el.setPointerCapture(e.pointerId);
    });
    el.addEventListener("pointermove", function (e) {
      if (!spin) return;
      mug.rotation.y = spin.ry + (e.clientX - spin.x) * 0.012;
    });
    el.addEventListener("pointerup", function () { spin = null; });
    el.addEventListener("pointercancel", function () { spin = null; });

    var reduceMotion = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var alive = true;
    (function loop() {
      if (!alive) return;
      if (!userTouched && !reduceMotion) mug.rotation.y += 0.004;
      renderer.render(scene, camera);
      requestAnimationFrame(loop);
    })();

    drawTexture();

    return {
      setPhoto: function (url) {
        if (url === photoUrl && photoImg) { drawTexture(); return; }
        photoUrl = url;
        photoImg = new Image();
        photoImg.onload = drawTexture;
        photoImg.src = url;
      },
      update: drawTexture,
      snapshot: function (done) {
        /* face the design to the camera for the order preview */
        mug.rotation.y = -0.35;
        renderer.render(scene, camera);
        renderer.domElement.toBlob(function (blob) {
          done(blob ? new File([blob], "design-preview.png", { type: "image/png" }) : null);
        }, "image/png", 0.92);
      },
      layout: function (done) {
        tex.toBlob(function (blob) {
          done(blob ? new File([blob], "print-layout.png", { type: "image/png" }) : null);
        }, "image/png", 0.95);
      },
      dispose: function () {
        alive = false;
        renderer.dispose();
      }
    };
  }

  function buildCompositePreview(overlay, st, done) {
    try {
      var base = overlay.querySelector(".ep-cz-base");
      var zone = overlay.querySelector("[data-zone]");
      var photoEl = overlay.querySelector("[data-photo]");
      var stageRect = base.getBoundingClientRect();
      var zoneRect = zone.getBoundingClientRect();
      var scaleUp = base.naturalWidth / stageRect.width;

      var canvas = document.createElement("canvas");
      canvas.width = base.naturalWidth;
      canvas.height = base.naturalHeight;
      var ctx = canvas.getContext("2d");
      ctx.drawImage(base, 0, 0);

      var zx = (zoneRect.left - stageRect.left) * scaleUp;
      var zy = (zoneRect.top - stageRect.top) * scaleUp;
      var zw = zoneRect.width * scaleUp;
      var zh = zoneRect.height * scaleUp;

      ctx.save();
      ctx.beginPath();
      ctx.rect(zx, zy, zw, zh);
      ctx.clip();

      if (st.url && photoEl && !photoEl.hidden) {
        var pr = photoEl.getBoundingClientRect();
        ctx.drawImage(photoEl,
          (pr.left - stageRect.left) * scaleUp, (pr.top - stageRect.top) * scaleUp,
          pr.width * scaleUp, pr.height * scaleUp);
      }
      if (st.text) {
        var fs = Math.round(zh * 0.11);
        ctx.font = "700 " + fs + "px Quicksand, sans-serif";
        ctx.textAlign = "center";
        ctx.lineWidth = fs * 0.18;
        ctx.strokeStyle = "rgba(255,255,255,.9)";
        ctx.fillStyle = "#2b2440";
        ctx.strokeText(st.text, zx + zw / 2, zy + zh - fs * 0.6);
        ctx.fillText(st.text, zx + zw / 2, zy + zh - fs * 0.6);
      }
      ctx.restore();

      canvas.toBlob(function (blob) {
        done(blob ? new File([blob], "design-preview.png", { type: "image/png" }) : null);
      }, "image/png", 0.92);
    } catch (err) {
      /* Canvas tainted or unsupported — order still gets photo + placement */
      done(null);
    }
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-ep-customize]");
    if (btn) openEpCustomizer(btn);
  });

  /* Debug helper: append ?epcz=1 to a product URL to auto-open the customiser */
  document.addEventListener("DOMContentLoaded", function () {
    if (location.search.indexOf("epcz=1") >= 0) {
      var btn = document.querySelector("[data-ep-customize]");
      if (btn) {
        openEpCustomizer(btn);
        var m = location.search.match(/eptxt=([^&]+)/);
        if (m) {
          setTimeout(function () {
            var t = document.querySelector(".customizer [data-text]");
            if (t) {
              t.value = decodeURIComponent(m[1]);
              t.dispatchEvent(new Event("input", { bubbles: true }));
            }
          }, 1500);
        }
      }
    }
  });

  /* Related products via the recommendations API */
  function loadRecommendations() {
    var el = document.querySelector("[data-related-products]");
    if (!el || !el.getAttribute("data-url")) return;
    fetch(el.getAttribute("data-url"))
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var fresh = doc.querySelector("[data-related-products]");
        if (fresh && fresh.querySelector(".card")) el.innerHTML = fresh.innerHTML;
      })
      .catch(function () {});
  }

  document.addEventListener("DOMContentLoaded", function () {
    refreshCartCount();
    loadRecommendations();
  });
})();
